// Campus photo for /colleges/morgan-state-university: CC0 1.0, by Baltimore Heritage from Baltimore, MD, USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHolmes_Hall%2C_Morgan_State_University%2C_1700_E._Coldspring_Lane%2C_Baltimore%2C_MD_21251_(34331315795).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/morgan-state-university/; credited under the photo.
const photo = {
    "slug": "morgan-state-university",
    "alt": "Holmes Hall, a stone building with a white columned entrance and clock tower, seen across the lawn at Morgan State University in Baltimore",
    "src": "/colleges/morgan-state-university/campus-1600.webp",
    "srcSmall": "/colleges/morgan-state-university/campus-800.webp",
    "srcMid": "/colleges/morgan-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/morgan-state-university/og.jpg",
    "title": "Holmes Hall, Morgan State University, 1700 E. Coldspring Lane, Baltimore, MD 21251 (34331315795)",
    "author": "Baltimore Heritage from Baltimore, MD, USA",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHolmes_Hall%2C_Morgan_State_University%2C_1700_E._Coldspring_Lane%2C_Baltimore%2C_MD_21251_(34331315795).jpg",
    "read": "2026-10-01"
};

export default photo;
